export default "__VITE_ASSET__625af632__"